import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import App from "./App";
import { ProfessionalAuthProvider } from "./auth/ProfessionalAuthContext";

const resolveWebBasename = () => {
  const baseFromVite = import.meta.env.BASE_URL || "/";
  if (baseFromVite === "./" || baseFromVite === "/") return "/";
  return baseFromVite.endsWith("/") ? baseFromVite.slice(0, -1) : baseFromVite;
};

const basename = Capacitor.isNativePlatform() ? "/" : resolveWebBasename();

createRoot(document.getElementById("root")!).render(
  <BrowserRouter basename={basename}>
    <ProfessionalAuthProvider>
      <App />
    </ProfessionalAuthProvider>
  </BrowserRouter>
);
